import React from "react";
import {DailyPoolForecastTable} from "../components/dailyPoolForecastTable/DailyPoolForecastTable";

import {Redirect, useHistory} from "react-router-dom";
import {Button, Col, Row} from "antd";
import {CreatePoolForecastModal} from "../components/createPoolForecastModal/CreatePoolForecastModal";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";

const DailyPoolForecasts = ({poolId}) => {
    const history = useHistory();
    const stores = useStore();
    const [recall, setRecall] = React.useState(false);
    const [createPoolForecastModalVisible, setCreatePoolForecastModalVisible] = React.useState(
        false
    );

    const [dailyForecastLoading, dailyForecast, ,] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.poolShiftStore.getDailyForecast.bind(null, {
            poolId: poolId
        }),
        dependencies: [recall],
        initialCall: Boolean(poolId),
        condition: Boolean(poolId)
    });

    const [shiftHoursLoading, shiftHours, setShiftHours] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.poolShiftStore.getShiftHours.bind(null, {}),
        dependencies: [],
        initialCall: true
    });

    return (
        <div>
            <Row style={{justifyContent: "space-between", marginBottom: "16px"}}>
                <b onClick={() => history.goBack()} style={{cursor: "pointer"}}>
                    {"<"} Geri Dön
                </b>
                <Button onClick={() => setCreatePoolForecastModalVisible(true)} type="primary">
                    + Yeni Forecast
                </Button>
            </Row>
            <CreatePoolForecastModal
                poolId={poolId}
                shiftHours={shiftHours?.data || []}
                visible={createPoolForecastModalVisible}
                setVisible={setCreatePoolForecastModalVisible}
                recall={() => setRecall(!recall)}
            />
            <DailyPoolForecastTable
                poolId={poolId}
                shiftHours={shiftHours?.data || []}
                loading={dailyForecastLoading}
                pagination={undefined}
                data={dailyForecast?.data || []}
                setData={setShiftHours}
                recall={() => setRecall(!recall)}
            />
        </div>
    );
};

export default DailyPoolForecasts;
